import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb"
}
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-item active" }
const _hoisted_6 = {
  key: 1,
  class: "breadcrumb"
}
const _hoisted_7 = { class: "breadcrumb-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.className])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      (!_ctx.pathList)
        ? (_openBlock(), _createElementBlock("ol", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: "/",
                alt: "Home",
                "aria-label": "Link para Home",
                class: "color--info"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    name: "house",
                    class: "color--info"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: `/${_ctx.routeHome}`,
                name: "home",
                class: "color--info"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("span", null, "Emissão de certificado", -1)
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/birdId/voucher",
                class: "color--primary"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "BirdID", -1)
                ])),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("ol", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/",
                alt: "Home",
                "aria-label": "Link para Home",
                class: "color--info"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    name: "house",
                    class: "color--info"
                  })
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pathList, (url, name) => {
              return (_openBlock(), _createElementBlock("li", {
                key: name,
                class: _normalizeClass([
            'breadcrumb-item',
            { active: name == _ctx.lastElementOfPathList },
          ])
              }, [
                _createVNode(_component_router_link, {
                  to: `/${url}`,
                  name: "home",
                  class: _normalizeClass([
              name == _ctx.lastElementOfPathList ? 'color--primary' : 'color--info',
            ])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              ], 2))
            }), 128))
          ]))
    ])
  ], 2))
}